import React, { useState } from 'react'
import ProductHeader from '@molecules/ProductHeader/ProductHeader'
import Availability from '@atoms/Availability/Availability'
import VariantSelector from '@atoms/VariantSelector/VariantSelector'
import Modal from '@molecules/Modal/Modal'
import BaseRichTextComponent from '@cms/RichText/BaseRichTextComponent'
import PriceTag from './PriceTag'
import * as T from './CommerceBox.types'
const isEmpty = require('lodash/isEmpty')
import { useConfig } from 'msp-integrations'

const CommerceBoxStage = ({
  product,
  CTAButton,
  innerRef,
  onAddToCart,
  onVariantChange,
  showTaxesInfo = true,
  smallDiscountPrice = false,
  displayExtendedInfo,
  isDarkMode = false,
  isMobile = false,
  isPDP = false,
  showLowestPrice
}: T.CommerceBoxStageProps) => {
  const {
    theme: { font, fontVariant }
  } = useConfig()
  const {
    price,
    c_basePrice,
    c_priceDiscounted,
    c_minSetPrice,
    currency,
    inventory,
    c_inventory,
    variants,
    variationAttributes,
    variant,
    c_classCategoryID,
    c_promotionCondition,
    c_promotionConditionLink,
    c_lastMonthPrice,
    c_lastMonthPriceCallback
  } = product
  const [openModalPromoCondition, setOpenModalPromoCondition] = useState(false)
  const { ats, orderable, preorderable, stockLevel, inStockDate } =
    inventory || c_inventory || {}

  const richTextData = {
    data: {
      richText: {
        value: c_promotionCondition || ''
      },
      hasCustomStyle: true
    },
    className: `${font.regular} flex flex-col w-full text-14 leading-24`
  }
  const ModalPromoConditionBody = () => (
    <BaseRichTextComponent {...richTextData} />
  )

  const ProductHeaderStyles = {
    container: `h-fit w-full pt-12 lg:pt-24 lg:px-0 mb-8 lg:mb-0 mx-auto flex flex-col ${
      font.medium
    } transition-colors duration-500 ${
      isDarkMode ? 'text-white' : 'text-black'
    }`,
    wrapper: 'relative mx-auto w-10/12 2xl:w-2/3',
    tag: `table text-14 leading-normal tracking-normal ${
      font.regular
    } py-2 px-3 w-fit ${
      isDarkMode ? 'text-black bg-white' : 'text-white bg-black'
    }`,
    preline: `table text-12 leading-[14px] tracking-[4px] uppercase font-light ${font.medium} w-fit`,
    productName: `${fontVariant.medium} text-36 leading-44 tracking-0.8 mb-8 mt-4`,
    shortDescription: `text-[15px] leading-24 tracking-[0.6px] mb-3 ${font.regular}`,
    longDescription: `text-[15px] leading-24 tracking-[0.6px] break-words hyphens-auto font-light ${font.regular} relative mb-5 text-justify`
  }

  return (
    <div className={'flex flex-col'}>
      {!isMobile && (
        <ProductHeader
          attributes={[]}
          longDescription={product?.longDescription || ''}
          name={product?.name || ''}
          promotionTag={product?.c_promotionMessage}
          shortDescription={product?.shortDescription || ''}
          styling={ProductHeaderStyles}
        />
      )}
      <div className={`mx-auto mt-5 ${ProductHeaderStyles.wrapper}`}>
        <div className={'grid w-full grid-rows-1 gap-5'} ref={innerRef}>
          {!isMobile && variants && variants.length > 0 && onVariantChange && (
            <VariantSelector
              variants={variants}
              variationAttributes={variationAttributes}
              variantSelected={variant}
              onVariantChange={onVariantChange}
              isDarkMode={isDarkMode}
              isGiftCert={c_classCategoryID === 'giftcards'}
              isPDP={isPDP}
            />
          )}
          <PriceTag
            className={`grid auto-cols-fr grid-flow-col grid-cols-[auto] items-center gap-4 transition-colors duration-500 ${
              isDarkMode ? 'text-white' : 'text-black'
            }`}
            discountPrice={c_priceDiscounted}
            c_basePrice={c_basePrice}
            price={c_minSetPrice || price}
            smallDiscountPrice={smallDiscountPrice}
            showTaxesInfo={showTaxesInfo}
            currency={currency}
            isPDP={false}
            alignBasePriceRight
            showLowestPrice={showLowestPrice}
            lastMonthPrice={c_lastMonthPrice}
            lastMonthPriceCallback={c_lastMonthPriceCallback}
          />
          <div className='flex items-center justify-between'>
            <div
              className={`flex w-full justify-end
          ${!orderable ? 'cursor-not-allowed' : 'cursor-pointer'}`}
              onClick={() => {
                if (onAddToCart && orderable) {
                  onAddToCart(1)
                }
              }}
            >
              {CTAButton}
            </div>
          </div>
          <div className='mb-4'>
            {(!isEmpty(inventory) || !isEmpty(c_inventory)) && (
              <Availability
                ats={ats}
                stockLevel={stockLevel}
                inStockDate={inStockDate}
                orderable={orderable}
                preorderable={preorderable}
              />
            )}
          </div>
          {displayExtendedInfo &&
            !isEmpty(c_promotionCondition) &&
            !isEmpty(c_promotionConditionLink) && (
              <>
                <div
                  className={`${font.regular} text-grayRegular text-14 leading-16 tracking-0.2 flex w-full cursor-pointer flex-col pt-4 text-right underline`}
                  onClick={() => setOpenModalPromoCondition(true)}
                >
                  {c_promotionConditionLink}
                </div>
                <Modal
                  isExtended={true}
                  isOpen={openModalPromoCondition}
                  onClose={() => setOpenModalPromoCondition(false)}
                  overlay
                  closeOnOverlayClick
                  blockScroll
                  modalBody={<ModalPromoConditionBody />}
                />
              </>
            )}
        </div>
      </div>
    </div>
  )
}

export default CommerceBoxStage
